var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActive9Dot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 176430",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 145263",
    style: {
      fill: "#fff",
      stroke: "#2162d5"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 145025",
    style: {
      fill: "#2162d5"
    },
    d: "M0 0h3.5v3.5H0z",
    transform: "translate(10 10)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 145026",
    transform: "translate(16.25 10)",
    style: {
      fill: "#2162d5"
    },
    d: "M0 0h3.5v3.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 145027",
    transform: "translate(22.5 10)",
    style: {
      fill: "#2162d5"
    },
    d: "M0 0h3.5v3.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 145028",
    transform: "translate(10 16.25)",
    style: {
      fill: "#2162d5"
    },
    d: "M0 0h3.5v3.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 145029",
    transform: "translate(16.25 16.25)",
    style: {
      fill: "#2162d5"
    },
    d: "M0 0h3.5v3.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 145030",
    transform: "translate(22.5 16.25)",
    style: {
      fill: "#2162d5"
    },
    d: "M0 0h3.5v3.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 145031",
    transform: "translate(10 22.5)",
    style: {
      fill: "#2162d5"
    },
    d: "M0 0h3.5v3.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 145032",
    transform: "translate(16.25 22.5)",
    style: {
      fill: "#2162d5"
    },
    d: "M0 0h3.5v3.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 145033",
    transform: "translate(22.5 22.5)",
    style: {
      fill: "#2162d5"
    },
    d: "M0 0h3.5v3.5H0z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive9Dot);
export default __webpack_public_path__ + "static/media/active9Dot.43dc1397738537b30bc43b183360e2a2.svg";
export { ForwardRef as ReactComponent };